import React, {useState,useRef, useContext} from "react";
import Button from 'react-bootstrap/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useForm } from "react-hook-form";

import { sendMessageWithImages } from "../service";
import Context from "../context";
import { theme } from "../../../../theme";
import BtnSpinner from "../../../../common/btnSpinner";
import ModalTemplateWithForm from "../../../../common/modal/modalTemplateWithForm";
import FileUploadWrapper from "../../../../common/FileUpload/FileUpload";

const ChatImageUpload = () => {
    const { files, setFiles, FileUpload } = FileUploadWrapper();
    const {
        register,
        handleSubmit,
        reset,
    } = useForm();

    const context = useContext(Context);

    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => {
        setFiles([]); // ✅ clear files on close
        setIsOpen(false); // close modal
    };

    return(
        <>
            <IconButton onClick={handleOpen}><AttachFileIcon /></IconButton>

            <ModalTemplateWithForm
                show={isOpen} 
                closeFun = {handleClose}
                size = {null}
                centered = {true}
                fullscreen = {false}
                dialogClassName = {null}
                title = {'UPLOAD YOUR IMAGE'}
                body = {
                    <>
                        {FileUpload}

                        <TextField 
                            ref={ref} 
                            size="small"
                            className="form-control mt-3" 
                            placeholder="Write your caption"
                            {...register("caption", { required: false })}
                        />
                    </>
                }
                footer = {
                    <>
                        <Button 
                            variant={theme.close_btn} 
                            onClick={() => setIsOpen(false)} 
                            disabled={context.state.is_loading_btn}
                            size="sm"
                            className=" mb-0"
                        >
                            {context.state.is_loading_btn ? (
                                <BtnSpinner/>
                            ) : (
                                "CLOSE"
                            )}
                            
                        </Button>
                        <Button 
                            variant={theme.action_btn} 
                            size="sm" 
                            disabled={context.state.is_loading_btn}
                            type="submit"
                            className=" mb-0"
                        >
                            {context.state.is_loading_btn ? (
                                <BtnSpinner/>
                            ) : (
                                <>
                                    <i className="fas fa-paper-plane" style={{fontSize: '12px'}}/> SEND
                                </>
                            )}
                        </Button>
                    </>
                }
                onSubmit = {handleSubmit((data) => sendMessageWithImages({
                    data: data, 
                    dispute: context.dispute,
                    images: files, 
                    dispatch: context.dispatch,
                    reset: reset, 
                    setIsOpen: setIsOpen
                }))}
            />
        </>
    );
}

export default ChatImageUpload;